import * as API_CONSTANT from '../constants'

import { report_handler } from '../../../handlers'

export const getDevicesCMS = (uid, sessionId) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/cms/device/get/all`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            uid,
            sessionId
        })
    })
    .then(res => res.json())
)

export const getDevicesStateCMS = (uid, sessionId) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/cms/deviceState/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            uid,
            sessionId
        })
    })
    .then(res => res.json())
)

export const getUserInfoCMS = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/cms/userInfo/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            username: '202893'
        })
    })
    .then(res => res.json())
)

export const createDeviceMDVR = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const updateDeviceMDVR = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getPassengerCount = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/passengerCount`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getDeviceMDVREvent = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/event/timeframe/get/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
    .then(res => (res.status === 200) && report_handler.fetchWithJSONConvertor(res, 'mdvrEvents') || res)
)


export const getDeviceMDVRInfoBatch = (mdvrids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/batch/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            mdvrids
        })
    })
    .then(res => res.json())
)

export const getDeviceMDVRGroupBatch = (mdvrgids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/batch/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            mdvrgids
        })
    })
    .then(res => res.json())
)

export const getDeviceGroupByMDVRGID = (mdvrids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            mdvrids
        })
    })
    .then(res => res.json())
)

export const getDisconnectedDeviceByVID = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/disconnected/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)
